import { data } from 'jquery';
import { loadingShow } from '../App';
import {
  AddEditOperationsByTemplate,
  AddOperations,
  getOperationsTemplateDetail,
} from '../services/Operations/OperationServices';
import Message from './Message/Message';

export const preparingTemplatePoint = async (
  order_datas: any,
  pm_id?: number
) => {
  let opTempDetail :any;
  let datas : Object[]=[];

  const ERP_TYPE = process.env.REACT_APP_ERP_TYPE;
  const erpTypeName = 'MEX';

  if(pm_id){
    opTempDetail= await getOperationsTemplateDetail(pm_id);

  }else{
    let operations:any[]=[];
    order_datas.map((order_data:any)=>{
      let data =  {  
          app: order_data.app,
          organizationId: order_data.organization_id,
          orderCode: order_data.order_code,
          orderId: order_data.order_id,
          assetCode: order_data.asset_code,
          priority: order_data.priority_code,
          workOrderType: order_data.type_code,
          scheduled_start_date: order_data.scheduled_start_date,
          scheduled_end_date: order_data.scheduled_end_date,
          plannedStartDate: order_data.planned_start_date,
          planned_end_date: order_data.planned_end_date,
          plannedEndTime: order_data.scheduledEndTime,
          plannedStartTime: order_data.scheduledStartTime,
          section: order_data.order_section_code,
          longDescription: order_data.description,
          orderDescription: order_data.description,
          operationDescription: 'DEFAULT ' + order_data.description,
          responsibility:order_data.order_resp_code,
          operationSequence: ERP_TYPE === erpTypeName ? 1 : 10,
          required: "1",
          estHours:"1",        
      }   
      operations.push(data);
    } 
    )      
    datas.push(operations)
  }
  if (opTempDetail?.data?.length === 0) {
    Message.error('No template to procced.');
    return;
  }
  loadingShow(true,'Just a sec.')

  order_datas.map((order_data:any)=>{
    if(opTempDetail){
      let data = opTempDetail?.data?.map((el: any) => {

        delete el?.rowstamp;
        delete el?.transaction_id;
        delete el?.transaction_code;
        console.log("el.long_description: ",el.long_description)
        console.log("el: ",el)
        return {
          app: order_data.app,
          organizationId: order_data.organization_id,
          orderCode: order_data.order_code,
          orderId: order_data.order_id,
          assetCode: order_data.asset_code,
          priority: order_data.priority_code,
          workOrderType: order_data.type_code,
          scheduled_start_date: order_data.scheduled_start_date,
          scheduled_end_date: order_data.scheduled_end_date,
          plannedStartDate: order_data.planned_start_date,
          planned_end_date: order_data.planned_end_date,
          plannedEndTime: order_data.scheduledEndTime,
          plannedStartTime: order_data.scheduledStartTime,
          section: order_data.order_section_code,
          duration: el.duration,
          required: el?.required &&(el.required),
          longDescription: order_data.description,
          orderDescription: order_data.description,
          operationDescription:ERP_TYPE === 'MEX' ? el.operation_description : el.long_description,
          responsibility:order_data.order_resp_code,
          estHours: el.est_hours,
          tradeCode: el.trade_code,
          tradeId: el.trade_id,
          statusCode: el.status_code,
          operationSequence: el.operation_sequence,
          pm_id: el.template_id,
        };
        
      }   
      );
      datas.push(data)
    }
    
  })
 

  AddEditOperationsByTemplate(datas)
    .then(() => {
      Message.success('Success');
      loadingShow(false);
    })
    .catch((err: any) => {
      if (err.response) {
        Message.error(
          err.response.data +
            '\n' +
            err.response.status +
            '\n' +
            err.response.headers
        );
      } else if (err.request) {
        Message.error(err.request);
      } else {
        Message.error('Error: ' + err.message);
      }
      loadingShow(false);
    });
};
